// extracted by mini-css-extract-plugin
module.exports = {"debug":"css-debug_debug_36qUL"};